import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconPhoneInTalkComponent } from "./med-icon-phone-in-talk.component";

@NgModule({
  declarations: [
    MedIconPhoneInTalkComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconPhoneInTalkComponent,
  ],
})
export class MedIconPhoneInTalkModule { }
